const BlindSpot = () => (
  <svg width="71" height="70" viewBox="0 0 71 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M31.7109 25.0309C31.5556 26.8989 32.072 28.8283 33.31 30.4273C34.548 32.0262 36.2865 33.0094 38.1339 33.3268M38.928 30.5396C37.6967 30.303 36.5431 29.6343 35.7152 28.565C34.8873 27.4957 34.5287 26.2114 34.6081 24.9601"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.2 39.3026C12.8492 38.1331 13.6189 36.9191 14.8326 36.7863C17.8819 36.4526 20.1792 36.4804 23.1685 36.7993C24.392 36.9298 25.1768 38.1506 24.8232 39.3292L24.3043 41.059C24.0505 41.905 23.2718 42.4843 22.3886 42.4843H15.6426C14.7594 42.4843 13.9807 41.905 13.7269 41.059L13.2 39.3026Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M13.6514 51.7129C15.1628 52.5226 19.4246 53.6561 24.3808 51.7129"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M23.9072 29.3252C23.484 28.791 22.3964 27.7129 21.4314 27.6747"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M13.8906 29.3252C14.3138 28.791 15.4015 27.7129 16.3664 27.6747"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M27.1175 36.6691V31.0264C27.1175 27.7127 24.4312 25.0264 21.1175 25.0264H16.9139C13.6002 25.0264 10.914 27.7126 10.9139 31.0263L10.9139 36.6691M27.1175 36.6691V50.682V52.9736C27.1175 55.735 24.879 57.9736 22.1175 57.9736H15.9139C13.1525 57.9736 10.914 55.7351 10.9139 52.9737L10.9139 50.682V36.6691M27.1175 36.6691C27.6576 36.8491 28.4678 36.9391 29.0079 38.2894M10.9139 36.6691C10.3737 36.8491 9.56356 36.9391 9.02344 38.2894"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M45.2 26.3026C44.8492 25.1331 45.6189 23.9191 46.8326 23.7863C49.8819 23.4526 52.1792 23.4804 55.1685 23.7993C56.392 23.9298 57.1768 25.1506 56.8232 26.3292L56.3043 28.059C56.0505 28.905 55.2718 29.4843 54.3886 29.4843H47.6426C46.7594 29.4843 45.9807 28.905 45.7269 28.059L45.2 26.3026Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M45.6514 38.7129C47.1628 39.5226 51.4246 40.6561 56.3808 38.7129"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M55.9072 16.3252C55.484 15.791 54.3964 14.7129 53.4314 14.6747"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M45.8906 16.3252C46.3138 15.791 47.4015 14.7129 48.3664 14.6747"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M59.1175 23.6691V18.0264C59.1175 14.7127 56.4312 12.0264 53.1175 12.0264H48.9139C45.6002 12.0264 42.914 14.7126 42.9139 18.0263L42.9139 23.6691M59.1175 23.6691V37.682V39.9736C59.1175 42.735 56.879 44.9736 54.1175 44.9736H47.9139C45.1525 44.9736 42.914 42.7351 42.9139 39.9737L42.9139 37.682V23.6691M59.1175 23.6691C59.6576 23.8491 60.4678 23.9391 61.0079 25.2894M42.9139 23.6691C42.3737 23.8491 41.5636 23.9391 41.0234 25.2894"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default BlindSpot;
